
import ProductIds from '../productIds';
import { getJson, LogCategory, log } from '../logger';
import Localizer from '../../format/localizer';
import {Settings} from '../settings';

export default class HostApp {

    constructor() {
        this.errorString = "";

        // this is the important info we get from HM3
        this.fingerprint = "";
        this.token = "";
        this.userEmail = "";
        this.userName = "";
        this.userId = 0;
        this.licenseId = "";
        this.version = "";
        this.license = [];
        this.enableTrialAbuseCheck = 0;
        this.fromStartup = true;
        this.language = "en";
    }

    static isActive(date, activeFlag) {
        if (activeFlag != 1)
            return false;
        if ( date === null)
            return true; // perpetual license

        var now = Date.now() ;

        var expires = Date.parse(date);
        // make sure 'date' is valid Date string
        console.assert(expires > 1);
        return (expires > now);
    }
    static isExpired(date, activeFlag) {
        if (activeFlag != 1)
            return false;
        if ( date === null)
            return false; // perpetual license

        var now = Date.now() ;

        var expires = Date.parse(date);
        // make sure 'date' is valid Date string
        console.assert(expires > 1);
        var expired = (expires < now);
        return expired;
    }

    static getMaxVersion(restrictions) {
        for ( var i in restrictions) {
            var restriction = restrictions[i];
            if ( restriction.name == 'MaxVersion')
                return restriction.value;
        }
        // highest version possible
        return "100.0.0.0";
    }

    isVersionLowerThanMaxVersion(maxVersion) {
        if ( this.version == "")
            return true;

        if ( Settings.simulateOverMaxVersion)
            return false;

        var ours = this.version.split('.');
        var max = maxVersion.split('.');
        var isLower = true;
        for ( var i = 0; i < 4; ++i) {
            var curOurs = parseInt( ours[i]);
            var curMax = parseInt( max[i]);
            if (curOurs != curMax) {
                isLower = curOurs < curMax;
                break;
            }
            // here, they are the same, go to the next sub-version
        }

        //log(LogCategory.info,"comparing " + this.version + " to " + maxVersion + " -> " + ( isLower ? "lower" : "higher" ));
        return isLower;
    }

    startup(jsonHostAnswer) {
        try {
            if ( typeof jsonHostAnswer === 'string')
                jsonHostAnswer = JSON.parse(jsonHostAnswer);

            if (typeof jsonHostAnswer.fingerprint !== 'undefined')
                this.fingerprint = jsonHostAnswer.fingerprint;

            if (jsonHostAnswer.language !== undefined)
                this.language = jsonHostAnswer.language;

            if (typeof jsonHostAnswer.userToken !== 'undefined')
                if (typeof jsonHostAnswer.userToken.token !== 'undefined')
                    this.token = jsonHostAnswer.userToken.token;

            if (typeof jsonHostAnswer.version !== 'undefined')
                this.version = jsonHostAnswer.version;

            if ( typeof jsonHostAnswer.enableTrialAbuseCheck !== 'undefined')
                this.enableTrialAbuseCheck = jsonHostAnswer.enableTrialAbuseCheck;

            if ( typeof jsonHostAnswer.fromStartup !== 'undefined')
                this.fromStartup = jsonHostAnswer.fromStartup;

            if (jsonHostAnswer.cached !== undefined) {
                // when the answer is build from HM3 internal data, not coming from the startup response
                var cached = jsonHostAnswer.cached;
                this.token = cached.token;
                this.userName = cached.name;
                this.userEmail = cached.email;
                this.userId = cached.userId;
                this.licenseId = cached.licenseId;
                this.license = cached.license.items;
            }


            if (typeof  jsonHostAnswer.application !== 'undefined')
                if (typeof  jsonHostAnswer.application.license !== 'undefined' && jsonHostAnswer.application.license !== null) {
                    if (typeof jsonHostAnswer.application.license.name !== 'undefined')
                        this.userName = jsonHostAnswer.application.license.name;

                    if (typeof jsonHostAnswer.application.license.name !== 'undefined')
                        this.userEmail = jsonHostAnswer.application.license.name;

                    if (typeof jsonHostAnswer.application.license.email !== 'undefined')
                        this.userEmail = jsonHostAnswer.application.license.email;

                    if (typeof jsonHostAnswer.application.license.id_user !== 'undefined')
                        this.userId = jsonHostAnswer.application.license.id_user;

                    // note: at this time, this is not really sent from HM3
                    if (typeof jsonHostAnswer.application.license.id_license !== 'undefined')
                        this.licenseId = jsonHostAnswer.application.license.id_license;

                    if ( typeof jsonHostAnswer.application.license.items !== 'undefined')
                        this.license = jsonHostAnswer.application.license.items;
                }


            if ( this.token == "" || this.version == "")
                this.errorString = "Invalid HM3 Startup.";
        } catch (e) {
            this.errorString = "Invalid HM3 Startup - " + JSON.stringify(e);
        }

        let hm3 = this._getActiveHm3LicenseProductId(this.license);
        let omaha = this._getActiveOmahaLicenseProductId(this.license);

        let result = {
            version: this.version,
            token: this.token,
            userEmail: this.userEmail,
            userName: this.userName,
            userId: this.userId,
            licenseId: this.licenseId,
            fromStartup: this.fromStartup,
            language: this.language,
            hmApps:  jsonHostAnswer && jsonHostAnswer.application && jsonHostAnswer.application.license !== undefined &&  jsonHostAnswer.application.license != null ? jsonHostAnswer.application.license.apps : [],

            errorString: this.errorString,
            enableTrialAbuseCheck: this.enableTrialAbuseCheck,

            hm3LicenseProductId: hm3.id,
            omahaLicenseProductId: omaha.id,
            hm3LicenseIsOverMaxVersion: hm3.isOverMaxVersion,
            omahaLicenseIsOverMaxVersion: omaha.isOverMaxVersion,
            hm3LicenseMaxVersion: hm3.maxVersion,
            omahaLicenseMaxVersion: omaha.maxVersion,


            // note: the freemium restrictions <- are needed only to show "Limited functionality" tooltip on Maintenance Page
            restrictionsHm3: this._getRestrictions( this._getHm3Restrictions(this.license)),
            restrictionsHm3Freemium: this._getRestrictions( this._getHm3FreemiumRestrictions(this.license)),
            restrictionsOmaha: this._getRestrictions( this._getOmahaRestrictions(this.license)),
            restrictionsOmahaFreemium: this._getRestrictions( this._getOmahaFreemiumRestrictions(this.license)),

            fingerprint: this.fingerprint,
            license: this.license,
        };

        return result;
    }

    _getActiveHm3LicenseProductId(license) {
        var all = this._getLicenseByProductId(license, ProductIds.hm3AllStakes);
        var small = this._getLicenseByProductId(license, ProductIds.hm3SmallStakes);
        var trial = this._getLicenseByProductId(license, ProductIds.hm3Trial);
        var freemium = this._getLicenseByProductId(license, ProductIds.hm3Freemium);
        var maintenace = this._getLicenseByProductId(license, ProductIds.hm3Maintenance);
        let isOverMaxVersion = false;
        let maxVersion = "";


        // if any of small stakes / all stakes is active -> use that
        // (the idea is - we could have a recently expired license + an active one)
        if ( all !== null && maintenace !== null && HostApp.isActive(maintenace.date_expires, maintenace.flg_active))
            return {
                id: ProductIds.hm3AllStakes, restrictionsId: ProductIds.hm3AllStakes, 
                isOverMaxVersion: isOverMaxVersion, maxVersion: maxVersion
            };
        if (  small !== null && maintenace !== null && HostApp.isActive(maintenace.date_expires, maintenace.flg_active))
            return {
                id: ProductIds.hm3SmallStakes, restrictionsId: ProductIds.hm3SmallStakes, 
                isOverMaxVersion: isOverMaxVersion, maxVersion: maxVersion
            };

        // if any of small stakes / all stakes is recently expired -> use that
        if ( all !== null && maintenace !== null && HostApp.isExpired(maintenace.date_expires, maintenace.flg_active)) {
            maxVersion = HostApp.getMaxVersion(all.restrictions);
            if ( this.isVersionLowerThanMaxVersion( HostApp.getMaxVersion(all.restrictions)))
                return {
                    id: ProductIds.hm3AllStakes, restrictionsId: ProductIds.hm3AllStakes, 
                    isOverMaxVersion: isOverMaxVersion, maxVersion: maxVersion
                };
            isOverMaxVersion = true;
            if ( freemium === null && trial === null)
                // license expired, but hasn't started a trial yet
                return {
                    id: ProductIds.hm3AllStakes, restrictionsId: ProductIds.hm3AllStakes, 
                    isOverMaxVersion: isOverMaxVersion, maxVersion: maxVersion
                };
        }
        if ( small !== null && maintenace !== null && HostApp.isExpired(maintenace.date_expires, maintenace.flg_active)) {
            maxVersion = HostApp.getMaxVersion(small.restrictions);
            if ( this.isVersionLowerThanMaxVersion( HostApp.getMaxVersion(small.restrictions)))
                return {
                    id: ProductIds.hm3SmallStakes, restrictionsId: ProductIds.hm3SmallStakes, 
                    isOverMaxVersion: isOverMaxVersion, maxVersion: maxVersion
                };
            isOverMaxVersion = true;
            if ( freemium === null && trial === null)
                // license expired, but hasn't started a trial yet
                return {
                    id: ProductIds.hm3SmallStakes, restrictionsId: ProductIds.hm3SmallStakes, 
                    isOverMaxVersion: isOverMaxVersion, maxVersion: maxVersion
                };
            if ( trial !== null)
                return {
                    id: ProductIds.hm3Trial, restrictionsId: ProductIds.hm3SmallStakes, 
                    isOverMaxVersion: isOverMaxVersion, maxVersion: maxVersion
                };
        }

        // if trial -> use that
        // note: if trial is expired is as if it hasn't been there
        if ( trial !== null && HostApp.isActive(trial.date_expires, trial.flg_active))
            return {
                id: ProductIds.hm3Trial, restrictionsId: ProductIds.hm3Trial, 
                isOverMaxVersion: isOverMaxVersion, maxVersion: maxVersion
            };

        // if freemium -> use that
        if ( freemium !== null) {
            return {
                id: ProductIds.hm3Freemium, restrictionsId: ProductIds.hm3Freemium, 
                isOverMaxVersion: isOverMaxVersion, maxVersion: maxVersion, 
                // find out if we initially had an ALL STAKES license that expired
                isFullLicense: (all !== null)
            };
        }

        // otherwise , 0
        return {id: 0, restrictionsId: 0, isOverMaxVersion: isOverMaxVersion, maxVersion: maxVersion};
    }

    _getActiveOmahaLicenseProductId(license) {
        var all = this._getLicenseByProductId(license, ProductIds.omahaAllStakes);
        var small = this._getLicenseByProductId(license, ProductIds.omahaSmallStakes);
        var trial = this._getLicenseByProductId(license, ProductIds.omahaTrial);
        var freemium = this._getLicenseByProductId(license, ProductIds.omahaFreemium);
        var maintenace = this._getLicenseByProductId(license, ProductIds.omahaMaintenance);
        let isOverMaxVersion = false;
        let maxVersion = "";

        // if any of small stakes / all stakes is active -> use that
        // (the idea is - we could have a recently expired license + an active one)
        if ( all !== null && maintenace !== null && HostApp.isActive(maintenace.date_expires, maintenace.flg_active))
            return {
                id: ProductIds.omahaAllStakes, restrictionsId: ProductIds.omahaAllStakes, 
                isOverMaxVersion: isOverMaxVersion, maxVersion: maxVersion
            } ;
        if (  small !== null && maintenace !== null && HostApp.isActive(maintenace.date_expires, maintenace.flg_active))
            return {
                id: ProductIds.omahaSmallStakes, restrictionsId: ProductIds.omahaSmallStakes, 
                isOverMaxVersion: isOverMaxVersion, maxVersion: maxVersion
            };

        // if any of small stakes / all stakes is recently expired -> use that
        if ( all !== null && maintenace !== null && HostApp.isExpired(maintenace.date_expires, maintenace.flg_active)) {
            maxVersion = HostApp.getMaxVersion(all.restrictions);
            if ( this.isVersionLowerThanMaxVersion( HostApp.getMaxVersion(all.restrictions)))
                return {
                    id:ProductIds.omahaAllStakes, restrictionsId: ProductIds.omahaAllStakes,
                    isOverMaxVersion: isOverMaxVersion, maxVersion: maxVersion
                };
            isOverMaxVersion = true;
        }
        if ( small !== null && maintenace !== null && HostApp.isExpired(maintenace.date_expires, maintenace.flg_active)) {
            maxVersion = HostApp.getMaxVersion(small.restrictions);
            if ( this.isVersionLowerThanMaxVersion( HostApp.getMaxVersion(small.restrictions)))
                return {
                    id: ProductIds.omahaSmallStakes, restrictionsId: ProductIds.omahaSmallStakes, 
                    isOverMaxVersion: isOverMaxVersion, maxVersion: maxVersion
                };
            isOverMaxVersion = true;
        }

        // if trial -> use that
        // note: if trial is expired is as if it hasn't been there
        if ( trial !== null && HostApp.isActive(trial.date_expires, trial.flg_active))
            return {
                id: ProductIds.omahaTrial, restrictionsId: ProductIds.omahaTrial, 
                isOverMaxVersion: isOverMaxVersion, maxVersion: maxVersion
            };

        // if freemium -> use that
        if ( freemium !== null)
            return {
                id: ProductIds.omahaFreemium, restrictionsId: ProductIds.omahaFreemium, 
                isOverMaxVersion: isOverMaxVersion, maxVersion: maxVersion,
                // find out if we initially had an ALL STAKES license that expired
                isFullLicense: (all !== null)
            };

        // otherwise , 0
        return {id: 0, restrictionsId: 0, isOverMaxVersion: isOverMaxVersion, maxVersion: maxVersion};
    }

    _getLicenseByProductId(license, productId) {
        for (var i in license) {
            var item = license[i];
            if ( item.id_product_variant == productId) {
                return item;
            }
        }
        return null;
    }

    _getHm3Restrictions(license) {
        var id = this._getActiveHm3LicenseProductId(license).restrictionsId;
        if ( id != 0)
            return this._getRawRestrictions(license, id);
        return [];
    }
    _getHm3FreemiumRestrictions(license) {
        return this._getRawRestrictions(license, ProductIds.hm3Freemium);
    }
    _getOmahaRestrictions(license) {
        var id = this._getActiveOmahaLicenseProductId(license).restrictionsId;
        if ( id != 0)
            return this._getRawRestrictions(license, id);
        return [];
    }
    _getOmahaFreemiumRestrictions(license) {
        this._getRawRestrictions(license, ProductIds.omahaFreemium);
    }

    // note: returns the restrictions ONLY if license hasn't already expired
    _getRawRestrictions(license, productId) {
        // if we have a subscription that expired recently, show it (and its restrictions)
        for (var i in license) {
            var item = license[i];
            if ( item.id_product_variant == productId) {
                if ( HostApp.isActive(item.date_expires, item.flg_active) || HostApp.isExpired(item.date_expires, item.flg_active))
                    return item.restrictions;
            }
        }
        return [];
    }


    _getRestrictions(srcRestrictions) {
        var restrictionsByName = {};

        restrictionsByName["RestrictNL"] = {
            restrictedTo: "",
            restrictedToExtra: [],
            isSummary: true,
            type: Localizer.format(Localizer.keys.restrictCashHandsType)
        };
        restrictionsByName["RestrictTny"] = {
            restrictedTo: "",
            restrictedToExtra: [],
            isSummary: true,
            type: Localizer.format(Localizer.keys.restrictTourneyType)
        };
        restrictionsByName["RestrictLimit"] = { restrictedTo:  "", restrictedToExtra: [], isSummary: true, type: Localizer.format(Localizer.keys.restrictLimitCashHandsType) };
        restrictionsByName["HudMaxTables"] = { restrictedTo: "", restrictedToExtra: [], isSummary: false, type: Localizer.format(Localizer.keys.restrictHudType) };
        restrictionsByName["ReportHandLimit"] = { restrictedTo: "", restrictedToExtra: [], isSummary: false, type: Localizer.format(Localizer.keys.restrictReportDataType) };

        for (var i in srcRestrictions) {
            var r = srcRestrictions[i];
            if (r.unit == "PLY")
                r.value = Localizer.format(Localizer.keys.restrictionUnlimited);

            switch (r.name) {
                case "RestrictNL":
                case "RestrictTny":
                    if (r.unit == null) {
                        restrictionsByName[r.name].restrictedTo = Localizer.format(Localizer.keys.restrictCashHands, [r.value]);
                    }
                    else
                        restrictionsByName[r.name].restrictedToExtra.push(r.unit + " " + r.value) ;
                    break;
                case "RestrictLimit":
                    if (r.unit == null) {
                        restrictionsByName[r.name].restrictedTo = Localizer.format(Localizer.keys.restrictLimitCashHands, [r.value]) ;
                    }
                    else
                        restrictionsByName[r.name].restrictedToExtra.push(r.unit + " " + r.value) ;
                    break;

                case "HudMaxTables":
                    restrictionsByName[r.name].restrictedTo =Localizer.format(Localizer.keys.restrictHud, [r.value]);
                    break;
                case "ReportHandLimit":
                    restrictionsByName[r.name].restrictedTo = Localizer.format(Localizer.keys.restrictReportData, [r.value]);
                    break;
            }
        }

        var allRestrictions = [
            restrictionsByName["RestrictNL"],
            restrictionsByName["RestrictTny"],
            restrictionsByName["RestrictLimit"],
            restrictionsByName["HudMaxTables"],
            restrictionsByName["ReportHandLimit"],
        ];

        var restrictions = [];
        if ( allRestrictions[0].restrictedTo !== "")
            restrictions.push(allRestrictions[0]);
        if ( allRestrictions[1].restrictedTo !== "")
            restrictions.push(allRestrictions[1]);
        if ( allRestrictions[2].restrictedTo !== "")
            restrictions.push(allRestrictions[2]);
        if ( allRestrictions[3].restrictedTo !== "")
            restrictions.push(allRestrictions[3]);
        if ( allRestrictions[4].restrictedTo !== "")
            restrictions.push(allRestrictions[4]);

        log(LogCategory.restriction,"restrictions=" + getJson(restrictions));

        return restrictions;
    }

};



// WEBPACK FOOTER //
// ./src/api/host/hostApp.js